t = require('app/scripts/views/internal/teacup-with-helpers')('header_signup_login')

module.exports = ->
  t.a '.header-btn.header-signup', { href: '/signup' + t.mustacheBlock('escapedReturnUrl', (-> '?returnUrl=' + t.mustacheVar('escapedReturnUrl'))) }, ->
    t.format 'sign-up'
  t.a '.header-btn.header-login.no-right-margin', { href: '/login' + t.mustacheBlock('escapedReturnUrl', (-> '?returnUrl=' + t.mustacheVar('escapedReturnUrl'))) }, ->
    t.format 'log-in'
